<template>
  <div class="card">
    <div class="card-header">
      <h5>Day Report</h5>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-4">
          <label for="departure-time" class="form-label">Report Type</label>
          <select 
            class="form-select" 
            v-model="daybookreport.type" 
            id="report_type" 
            aria-label="Default select example"
            style="height: auto;"
          >
            <option value="">Select Report Type</option>
            <option value="report">Report</option>
            <option value="csv">CSV</option>
          </select>
          
        </div>
        <template v-if="daybookreport.type == 'report'">
          <div class="col-md-4">
            <label for="departure-time" class="form-label">Booking Date</label>
              <dateTimePicker
                no-label
                label="Select Booking Date"
                id="booking_date"
                format="YYYY-MM-DD"
                formatted="YYYY-MM-DD"
                v-model="daybookreport.start_date"
                :only-date="true"
                button-color="#ec391e"
                color="#ec391e"
                style="border: 1px solid #DFE5F9"
              />
              <small class="text-danger" v-if="daybookerror">{{ daybookerror }}</small>
          </div>
        </template>
        <template v-else>
          <div class="col-md-8">
            <div class="row">
              <div class="col-md-12">
                <h6>Booking Date Range</h6>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-6">
                <dateTimePicker
                  no-label
                  label="From Date"
                  id="departureDateRangeStart"
                  format="YYYY-MM-DD"
                  formatted="YYYY-MM-DD"
                  button-color="#ec391e"
                  color="#ec391e"
                  :only-date="true"
                  style="border: 1px solid #DFE5F9"
                  v-model="daybookreport.start_date"
                />
              </div>
              <div class="col-md-6">
                <dateTimePicker
                  no-label
                  label="To Date"
                  id="departureDateRangeEnd"
                  format="YYYY-MM-DD"
                  formatted="YYYY-MM-DD"
                  button-color="#ec391e"
                  color="#ec391e"
                  :only-date="true"
                  v-model="daybookreport.end_date"
                  :min-date="daybookreport.start_date"
                  style="border: 1px solid #DFE5F9"
                />
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-12">
                <small class="text-danger" v-if="daybookerror">{{ daybookerror }}</small>
              </div>
            </div>  
          </div>
        </template>
      </div>
    </div>
    <div class="card-footer align-items-right">
      <button
          type="submit"
          class="button"
          v-on:click.prevent="getDayBookingReport"
        >
        Generate report    
      </button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "DayReportFields",
  data() {
    return {
      daybookreport: {
        type: 'report',
        start_date: null,
        end_date: null
      },
      daybookerror:null,
      errors: null,
    };
  },
  methods: {
    getDayBookingReport() {
      const request = {
        type: this.daybookreport.type,
        start_date: this.daybookreport.start_date,
        end_date: this.daybookreport.end_date
      }

      if (request.type === '') {
        this.daybookerror = "Please select a valid report type"
        return
      }

      if (request.type === 'csv' && !request.start_date) {
        this.daybookerror = "Please select a valid booking Start date"
        return
      } else if (request.type === 'csv' && (!request.start_date || !request.end_date)) {
        this.daybookerror = "Please select a valid booking date range"
        return
      } else if (request.type === 'report' && !request.start_date) {
        this.daybookerror = "Please select a valid booking date"
        return
      } else {
        this.daybookerror = null
      }

      
      let reportName = 'Day-Report.xlsx';
      if (request.type === 'csv') {
        const formattedStartDate = new Date(request.start_date).toLocaleDateString('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: '2-digit'
        }).replace(/\//g, '-'); // Format date as DD-MM-YY
        const formattedEndDate = new Date(request.end_date).toLocaleDateString('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: '2-digit'
        }).replace(/\//g, '-'); // Format date as DD-MM-YY

        reportName = `Day-Report-Import(${formattedStartDate}/${formattedEndDate}).csv`;
      }

      this.$store.dispatch("setLoadStatus");
      fetch(this.$api + 'reports/daybook', {
        method: 'POST',
        body: JSON.stringify(request),
        headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then((res) => {
        if(res.status === 200) {
          this.$store.dispatch('setLoadStatus')
          res.blob().then(response => {
            const _url = window.URL.createObjectURL(response)
            const link = document.createElement('a')
            link.href = _url
            link.setAttribute('download', reportName)
            document.body.appendChild(link)
            link.click();
          })
        } else {
          this.$store.dispatch('setLoadStatus')
          Promise.race([res.json()])
          .then(response => {
            if(response.message) {
              this.$notify({
                type: 'error',
                title: response.message
              });
            } else {
              this.$notify({
                type: 'error',
                title: response.error
              });
            }
          })
        }
      })
    }
  }
};
</script>
